import axios from "../utils/axios";

export const getList = () => {
    return axios.get("/Pool/GetList");
};
export const getTaskList = (data) => {
    return axios.post("/PlannedMaintenance/GetTaskList", data);
};

export const getTaskSchedule = (filter) => {
    return axios.post("/PlannedMaintenance/GetTaskSchedule", filter);
};
export const getupdateTaskDate = (payload) => {
    return axios.post("/PlannedMaintenance/UpdateTaskDate", payload);
};
export const getStatusList = () => {
    return axios.get("/PlannedMaintenance/GetStatusList");
};
export const getMainListByAreaID = (areaID) => {
    return axios.get("/Equipment/GetMainListByAreaID?areaId=" + areaID);
};
export const getSubListById = (mainEquipmentID) => {
    return axios.get("/Equipment/GetSubListById?equipmentId=" + mainEquipmentID);
};

export const getAreaList = () => {
    return axios.get("/Area/GetList");
};

export const getTaskDetailById = (clickedEventId) => {
    return axios.get("PlannedMaintenance/GetTaskDetailById?id=" + clickedEventId);
};

export const getListMaintenanceType = () => {
    return axios.get("/MaintenanceType/GetList");
};

export const getEquipmentSubListById = (areaID) => {
    return axios.get("/Equipment/GetMainListByAreaID?areaId=" + areaID);
};
